import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage = '/og-image.jpg',
  canonical 
}) => {
  const location = useLocation()
  const baseUrl = 'https://totalrewardspro.com'
  
  const defaultTitle = 'Total Rewards Pro - People. Purpose. Pay. Perfectly Aligned.'
  const defaultDescription = 'Transform your compensation strategy with our proven methodology. Expert total rewards consulting for equity compensation, executive pay, and benefits design. Move beyond benchmarking to value-driven rewards systems.'
  const defaultKeywords = 'comprehensive HR services, total rewards consulting, compensation strategy, equity compensation, executive compensation, performance appraisals, variable pay design, ESOP consulting, CXO compensation, benefits design, HR policies, HR compliance, MECE framework, purpose-driven compensation, value-based rewards, stock options, salary benchmarking, benefits advisory, compensation benchmarking, regional compensation, startup compensation, compensation consulting firm'

  const pageTitle = title ? `${title} | Total Rewards Pro` : defaultTitle
  const pageDescription = description || defaultDescription
  const pageKeywords = keywords || defaultKeywords
  const pageCanonical = canonical || `${baseUrl}${location.pathname}`
  const pageOgImage = `${baseUrl}${ogImage}`

  useEffect(() => {
    // Update title
    document.title = pageTitle

    // Update meta tags
    const updateMetaTag = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`
      let element = document.querySelector(selector)
      
      if (element) {
        element.setAttribute('content', content)
      } else {
        element = document.createElement('meta')
        if (property) {
          element.setAttribute('property', name)
        } else {
          element.setAttribute('name', name)
        }
        element.setAttribute('content', content)
        document.head.appendChild(element)
      }
    }

    // Update canonical link
    const updateCanonical = (href) => {
      let canonical = document.querySelector('link[rel="canonical"]')
      if (canonical) {
        canonical.setAttribute('href', href)
      } else {
        canonical = document.createElement('link')
        canonical.setAttribute('rel', 'canonical')
        canonical.setAttribute('href', href)
        document.head.appendChild(canonical)
      }
    }

    // Update all meta tags
    updateMetaTag('description', pageDescription)
    updateMetaTag('keywords', pageKeywords)
    
    // Open Graph
    updateMetaTag('og:title', pageTitle, true)
    updateMetaTag('og:description', pageDescription, true)
    updateMetaTag('og:url', pageCanonical, true)
    updateMetaTag('og:image', pageOgImage, true)
    
    // Twitter
    updateMetaTag('twitter:title', pageTitle, true)
    updateMetaTag('twitter:description', pageDescription, true)
    updateMetaTag('twitter:url', pageCanonical, true)
    updateMetaTag('twitter:image', pageOgImage, true)
    
    // Canonical
    updateCanonical(pageCanonical)

  }, [pageTitle, pageDescription, pageKeywords, pageCanonical, pageOgImage])

  return null
}

export default SEO 